module.exports = __webpack_public_path__ + "static/media/wonderdynamics_ai.f3d29231.png";